import { Row, Col } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import Form from "react-bootstrap/Form";
import BackArrow from "../../backArrow";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PersonalImage from "../../../helpers/fileUpload";
import { Category } from "../../../constants/jsonConstant";
import LocationModal from "../../locationmodal/LocationModal";
import {
  useGetWorldCitiesQuery,
  useLazyGetShopCategoriesQuery,
} from "../../../features/shop/shopApiSlice";
import {
  useGetServiceDetailQuery,
  useCreateServiceMutation,
  useUpdateServiceMutation,
} from "../../../features/service/serviceApiSlice";
import { SuccessNotify, FailedNotify } from "../../../constants/tostify";
import { useSelector } from "react-redux";
import Button from "react-bootstrap/Button";
import { images } from "../../../constants";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import Card from "react-bootstrap/Card";
import Loader from "../../Loader";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import { publishImage } from "../../../helpers/imageupload";
import { useDropzone } from "react-dropzone";
import { getAsset } from "../../../helpers/helper";
import "./style.css";
import TermsModal from "../../modals/TermsModal";

const ServiceForm = (props) => {
  const { id } = useParams();
  const location = useLocation();
  const { name } = useSelector((state) => state.user);
  
  const formikRef = useRef(null);

  const [shopCategory, setShopCategory] = useState();
  const [shopCategorytwo, setShopCategorytwo] = useState();
  const [selectedCountry, setSelectedCountry] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const [selectedstateone, setSelectedstateone] = useState("");
  const [searchTermone, setSearchTermone] = useState("");

  const [selectedcity, setSelectedcity] = useState("");
  const [searchTermtwo, setSearchTermtwo] = useState("");

  // Function to handle the country selection
  const handleCountryChange = (event) => {
    const { value } = event.target;
    setSelectedCountry(value);
  };

  // Function to handle the state selection
  const handleCountryChangestate = (event) => {
    const { value } = event.target;
    setSelectedstateone(value);
  };

  // Function to handle the city selection
  const handleCountryChangecity = (event) => {
    const { value } = event.target;
    setSelectedcity(value);
  };

  const [hidefield, setHidefield] = useState(1);
  const [hidestate, setHidestate] = useState(1);
  const [hidecity, setHidecity] = useState(1);
  const [countrydata, SetCountrydata] = useState([]);
  const [getcountry] = useState();
  const [selectedState] = useState();
  const [getState, setState] = useState([]);
  const [getcity, setGetcity] = useState([]);
  const [statetwo, setStatetwo] = useState(getcountry);
  const [city, setCity] = useState(selectedState);
  const { data: citiesData } = useGetWorldCitiesQuery();
  useEffect(() => {
    if (citiesData) {
      SetCountrydata(citiesData);
    }
  }, [citiesData]);

  const country = [...new Set(countrydata.map((item) => item.country))];

  country.sort();
  const handleCountry = (e) => {
    let states = countrydata.filter(
      (state) => state.country === e.target.value,
    );
    states = [...new Set(states.map((item) => item.subcountry))];
    states.sort();
    setState(states);
  };

  const handleState = (e) => {
    let cities = countrydata.filter(
      (city) => city.subcountry === e.target.value,
    );
    setGetcity(cities);
  };

  const [data, setData] = useState({
    category: "",
    subCategory: "",
  });

  const Handledata = (e) => {
    setData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value.split("."),
    }));
  };
  const categoryName = data?.category[1];
  const categoryid = data.category[0];
  const subcategoryName = data?.subCategory[1];
  const subcategoryid = data.subCategory[0];
  localStorage.setItem("mycategory", categoryName);

  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [displayimg, setDisplayimg] = useState();

  const onDrop = async (acceptedFiles) => {
    try {
      setIsUploading(true);
      setUploadProgress(0);

      const abc = await publishImage(acceptedFiles, (percent) => {
        setUploadProgress(percent);
      });

      setCreateService((createService) => ({
        ...createService,
        images: abc,
      }));

      setDisplayimg(abc);
    } catch (error) {
      FailedNotify("Failed! Try Again");
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop,
  });

  const [isloading, setIsloading] = useState(false);
  const [createService, setCreateService] = useState({
    userid: name?._id,
    profileName: "",
    category: "",
    categoryid: "",
    subCategory: "",
    subCategoryid: "",
    country: "",
    state: "",
    city: "",
    cnic: "",
    address: "",
    videoTitle: "",
    imageTitle: "",
    videoDescription: "",
    imageDescription: "",
    videos: [],
    images: [""],
    portfolioimages: [""],
    status: true,
  });

  useEffect(() => {
    setCreateService((createService) => ({
      ...createService,
      category: categoryName,
      categoryid: categoryid,
      subCategory: subcategoryName,
      subCategoryid: subcategoryid,
    }));
  }, [categoryid, categoryName, subcategoryName, subcategoryid]);

  const navigate = useNavigate();

  const [getShopCategories] = useLazyGetShopCategoriesQuery();
  const { data: itemDetailData } = useGetServiceDetailQuery(id, { skip: !id });
  const [createServiceMutation] = useCreateServiceMutation();
  const [updateServiceMutation] = useUpdateServiceMutation();

  useEffect(() => {
    if (itemDetailData?.success) {
      setCreateService(itemDetailData.data.Service);
    }
  }, [itemDetailData]);

  useEffect(() => {
    getShopCategories({ type: "services", parentCategory: "" })
      .unwrap()
      .then((response) => {
        if (response?.success) {
          setShopCategory(response?.data?.Category);
        }
      })
      .catch(() => {});
  }, []);

  const Mydata = () => {
    if (data?.category) {
      getShopCategories({ type: "services", parentCategory: categoryName })
        .unwrap()
        .then((response) => {
          if (response?.success) {
            setShopCategorytwo(response?.data?.Category);
          }
        })
        .catch(() => {});
    }
  };

  const [selectedImage, setSelectedImage] = useState("");

  const removeImage = (index) => {
    const updatedImages = [...displayimg];
    updatedImages.splice(index, 1);
    setDisplayimg(updatedImages);
  };

  const handleValue = (event) => {
    setCreateService((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const formSericeSubmit = async (e) => {
    e.preventDefault();
    setIsloading(true);
    try {
      const response = await createServiceMutation(createService).unwrap();
      if (response?.success) {
        setIsloading(false);
        SuccessNotify("Service-Form Created SuccesFully...");
        navigate(`/service-business-profile/${response?.data?._id}`);
      }
    } catch (error) {
      setIsloading(false);
      FailedNotify("Failed to Create Form");
    }
  };

  const servcieFormupdate = async (e) => {
    e.preventDefault();
    try {
      const response = await updateServiceMutation({
        id,
        data: createService,
      }).unwrap();
      if (response?.success) {
        setTimeout(() => {
          SuccessNotify("Update Service SuccessFully");
          navigate(`/services-profile/${id}`);
        }, 3000);
      }
    } catch (error) {
      FailedNotify("Failed to Update Form");
    }
  };

  const validationSchema = Yup.object({
    category: Yup.string().required("category is required*"),
    subCategory: Yup.string().required("subcategory is required*"),
    profileName: Yup.string().required("Service name is required*"),
    country: Yup.string().required("country is required*"),
    state: Yup.string().required("state is required*"),
    city: Yup.string().required("city is required*"),
    cnic: Yup.string().required("cnic is required*"),
    address: Yup.string().required("address is required*"),
  });
  const userCity = name?.MCity || name?.address?.city;
  const [mshow, setMshow] = useState(false);
  const [showTermsSvcModal, setShowTermsSvcModal] = useState(false);
  const [termsAcceptedSvc, setTermsAcceptedSvc] = useState(false);
  const [termsErrorSvc, setTermsErrorSvc] = useState(false);
  const handleClose = () => setMshow(false);
  const handleShow = () => setMshow(true);

  // Sync LocationModal changes (which update createService) back into Formik so validation passes
  useEffect(() => {
    if (formikRef.current) {
      if (createService.address !== formikRef.current.values.address) {
        formikRef.current.setFieldValue("address", createService.address || "");
        formikRef.current.setFieldTouched("address", true);
      }
      if (createService.country !== formikRef.current.values.country) {
        formikRef.current.setFieldValue("country", createService.country || "");
        formikRef.current.setFieldTouched("country", true);
      }
      if (createService.state !== formikRef.current.values.state) {
        formikRef.current.setFieldValue("state", createService.state || "");
        formikRef.current.setFieldTouched("state", true);
      }
      if (createService.city !== formikRef.current.values.city) {
        formikRef.current.setFieldValue("city", createService.city || "");
        formikRef.current.setFieldTouched("city", true);
      }
    }
  }, [createService.address, createService.country, createService.state, createService.city]);

  if (isloading) {
    return (
      <div>
        <Loader heightsetting="screenHeight" />
      </div>
    );
  }

  return (
    <>
      <TermsModal show={showTermsSvcModal} onClose={() => setShowTermsSvcModal(false)} formTitle={props.title || "Service"} />
      <LocationModal
        mshow={mshow}
        handleClose={handleClose}
        userCity={userCity}
        createShop={createService}
        setCreateShop={setCreateService}
      />
      {selectedImage && <PersonalImage image={selectedImage} />}
      <Row className="service-form-row">
        <div className="service-form-page screenHeight d-flex justify-content-center align-items-center">
          <Col
            xl={8}
            lg={8}
            md={10}
            sm={12}
            xs={12}
            className="service-form-card Form-Shadow mt-5"
          >
            <div className="arrowback ps-3">
              <BackArrow back="/SellingSide" black="black" mystyle="p-1 ps-3" />
            </div>
            <div className="">
              <Formik
                innerRef={formikRef}
                initialValues={{
                  profileName: "",
                  category: "",
                  subCategory: "",
                  country: "",
                  state: "",
                  city: "",
                  cnic: "",
                  address: "",
                }}
                // validateOnChange={false}
                validateOnBlur={false}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                  // same shape as initial values
                }}
              >
                {({
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  errors,
                  touched,
                  isValid,
                  dirty,
                }) => (
                  <Form>
                    <div>
                      <h4 className="createHeading pt-3 ps-5">{props.title}</h4>
                    </div>
                    <Row className="ps-5 pe-5">
                      <Col md={4} lg={4} xl={4}>
                        <Form.Label className="custm-lble-2 pt-2">
                          Add Profile Name
                        </Form.Label>
                        <Form.Control
                          placeholder="Add Service Profile"
                          name="profileName"
                          value={createService?.profileName || ""}
                          onChange={(e) => {
                            handleValue(e);
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                          className="form-control-seller"
                        />

                        {errors.profileName && touched.profileName ? (
                          <div>
                            <p className="error_text_color">
                              {errors.profileName}
                            </p>
                          </div>
                        ) : null}
                      </Col>

                      <Col md={4} lg={4} xl={4}>
                        <Form.Label className="custm-lble-2 pt-2">
                          Category
                        </Form.Label>
                        <Form.Select
                          className="form-control-seller "
                          placeholder="Sub-Category"
                          name="category"
                          onChange={(e) => {
                            handleValue(e);
                            handleChange(e);
                            Handledata(e);
                          }}
                          onBlur={handleBlur}
                        >
                          {createService?.category?.length > 0 ? (
                            <option> {createService?.category}</option>
                          ) : (
                            <option>Select-Category</option>
                          )}

                          {/* <option> select Category</option> */}
                          {shopCategory?.map((category) => (
                            <option
                              key={category._id}
                              value={`${category?._id}.${category?.name}`}
                            >
                              {category?.name}
                            </option>
                          ))}
                        </Form.Select>
                        {errors.category && touched.category ? (
                          <div>
                            <p className="error_text_color">
                              {errors.category}
                            </p>
                          </div>
                        ) : null}
                      </Col>

                      <Col lg="4">
                        <Form.Label className="custm-lble-2 pt-2 ">
                          Sub-Category
                        </Form.Label>
                        <Form.Select
                          className="  form-control-seller"
                          placeholder="Sub-Category"
                          name="subCategory"
                          onClick={Mydata}
                          onChange={(e) => {
                            handleValue(e);
                            handleChange(e);
                            Handledata(e);
                          }}
                          onBlur={handleBlur}
                        >
                          {createService?.subCategory?.length > 0 ? (
                            <option> {createService?.subCategory}</option>
                          ) : (
                            <option>select Sub-Category</option>
                          )}

                          {/* <option> select Sub-Category</option> */}
                          {shopCategorytwo?.map((category) => (
                            <option
                              key={category._id}
                              value={`${category?._id}.${category?.name}`}
                            >
                              {category?.name}
                            </option>
                          ))}
                        </Form.Select>
                        {errors.subCategory && touched.subCategory ? (
                          <div>
                            <p className="error_text_color">
                              {errors.subCategory}
                            </p>
                          </div>
                        ) : null}
                      </Col>
                    </Row>

                    <Row className="ps-5 pe-5 mt-2">
                      <Col md={4} lg={4} xl={4}>
                        <Form.Label className="custm-lble-2 pt-2">
                          Shop Address
                        </Form.Label>
                        <Form.Control
                          placeholder="Add Address with maps"
                          name="address"
                          value={createService?.address || ""}
                          className="form-control-seller"
                          onChange={(e) => {
                            handleValue(e);
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                        />
                        <div className="position-relative">
                          <img
                            onClick={handleShow}
                            className="iMg cursor_P"
                            src={images.FindClinic}
                            alt=""
                          />
                        </div>
                        {errors.address && touched.address ? (
                          <div>
                            <p className="error_text_color">{errors.address}</p>
                          </div>
                        ) : null}
                      </Col>

                      <Col md={4} lg={4} xl={4}>
                        <Form.Label className="custm-lble-2 pt-2">
                          CNIC or Licence Number
                        </Form.Label>
                        <Form.Control
                          placeholder="Licence Number/CNIC"
                          name="cnic"
                          value={createService?.cnic || ""}
                          className="form-control-seller"
                          onChange={(e) => {
                            handleValue(e);
                            handleChange(e);
                          }}
                          onBlur={handleBlur}
                        />
                        {errors.cnic && touched.cnic ? (
                          <div>
                            <p className="error_text_color">{errors.cnic}</p>
                          </div>
                        ) : null}
                      </Col>

                      <div className="col-lg-4 col-md-4 col-12">
                        <label
                          htmlFor="inputPassword4"
                          placeholder="First name"
                          className="form-label labelSize"
                        >
                          Country*
                        </label>
                        <div className="blood-type form-control-seller mt-1">
                          <select
                            onClick={() => setHidefield(1)}
                            value={selectedCountry}
                            onChange={(e) => {
                              handleCountryChange(e);
                              handleCountry(e);
                              handleValue(e);
                              handleChange(e);
                            }}
                            className="b-radius selectSize w-100"
                            name="country"
                            onBlur={handleBlur}
                          >
                            {hidefield && createService?.country?.length > 0 ? (
                              <option> {createService?.country}</option>
                            ) : (
                              <option>Select-Country</option>
                            )}
                            {country
                              .filter((country) =>
                                country
                                  .toLowerCase()
                                  .includes(searchTerm.toLowerCase()),
                              )
                              .map((country, index) => (
                                <option key={country} value={getcountry}>
                                  {country}
                                </option>
                              ))}
                          </select>
                        </div>
                        {errors.country && touched.country ? (
                          <div>
                            <p className="error_text_color">{errors.country}</p>
                          </div>
                        ) : null}
                      </div>
                    </Row>

                    <Row className="ps-5 pe-5 mt-2">
                      <div className="col-md-4">
                        <label
                          htmlFor="inputPassword4"
                          placeholder="First name"
                          className="form-label labelSize"
                        >
                          State*
                        </label>
                        <div className="blood-type form-control-seller mt-1">
                          <select
                            onClick={() => setHidestate(1)}
                            className="b-radius selectSize w-100 "
                            value={selectedstateone}
                            aria-label="Default select example "
                            name="state"
                            onChange={(e) => {
                              handleValue(e);
                              handleChange(e);
                              handleState(e);
                              handleCountryChangestate(e);
                            }}
                            onBlur={handleBlur}
                          >
                            {hidefield && createService?.state?.length > 0 ? (
                              <option> {createService?.state}</option>
                            ) : (
                              <option>Select-State</option>
                            )}

                            {getState
                              .filter((country) =>
                                country
                                  .toLowerCase()
                                  .includes(searchTermone.toLowerCase()),
                              )
                              .map((country) => (
                                <option key={country} value={selectedState}>
                                  {country}
                                </option>
                              ))}
                          </select>
                        </div>
                        {errors.state && touched.state ? (
                          <div>
                            <p className="error_text_color">{errors.state}</p>
                          </div>
                        ) : null}
                      </div>

                      <div className="col-md-4">
                        <label
                          htmlFor="inputPassword4"
                          placeholder="First name"
                          className="form-label labelSize"
                        >
                          City
                        </label>
                        <div className="blood-type form-control-seller mt-1">
                          <select
                            onClick={() => setHidecity(1)}
                            value={selectedcity}
                            className="b-radius selectSize w-100"
                            aria-label="Default select example"
                            name="city"
                            onChange={(e) => {
                              handleValue(e);
                              handleChange(e);
                              handleCountryChangecity(e);
                            }}
                            onBlur={handleBlur}
                          >
                            {hidefield && createService?.city?.length > 0 ? (
                              <option> {createService?.city}</option>
                            ) : (
                              <option>Select-City</option>
                            )}

                            {getcity
                              .filter((country) =>
                                country.name
                                  .toLowerCase()
                                  .includes(searchTermtwo.toLowerCase()),
                              )
                              .map((country) => (
                                <option key={country.name}>
                                  {country.name}
                                </option>
                              ))}
                          </select>
                        </div>
                        {errors.city && touched.city ? (
                          <div>
                            <p className="error_text_color">{errors.city}</p>
                          </div>
                        ) : null}
                      </div>
                    </Row>

                    <Row className="ps-5 pe-5 mt-5">
                      <Col>
                        <Row>
                          <Col lg="9" className="me-auto">
                            <Row>
                              <Col lg={3} className="mt-2 ms-1">
                                <Card
                                  style={{
                                    width: "6rem",
                                    height: "6rem",
                                    position: "relative", // ✅ to position loader
                                  }}
                                  {...getRootProps()}
                                  className="dropzone"
                                >
                                  {/* Show loader if uploading */}
                                  {isUploading ? (
                                    <div
                                      style={{
                                        position: "absolute",
                                        inset: 0,
                                        background: "rgba(255,255,255,0.7)",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        flexDirection: "column",
                                        borderRadius: "0.5rem",
                                      }}
                                    >
                                      <div
                                        className="spinner-border text-primary"
                                        style={{
                                          width: "1.5rem",
                                          height: "1.5rem",
                                        }}
                                        role="status"
                                      ></div>
                                      <small className="mt-1">
                                        {uploadProgress}%
                                      </small>
                                    </div>
                                  ) : (
                                    <>
                                      <Card.Img
                                        className="imet-fit"
                                        src={images.AddImage}
                                      />
                                      <Card.Body>
                                        <input
                                          type="file"
                                          id="file"
                                          style={{ display: "none" }}
                                          {...getInputProps()}
                                          multiple
                                          autoComplete="off"
                                        />
                                      </Card.Body>
                                    </>
                                  )}
                                </Card>
                              </Col>

                              {displayimg?.length > 0 && (
                                <Col
                                  lg={7}
                                  className="service-form-image-list mt-1 d-flex"
                                >
                                  {displayimg.map((image, index) => (
                                    <Card
                                      key={index}
                                      className="mt-1"
                                      style={{
                                        width: "6rem",
                                        height: "6rem",
                                        border: "2px solid",
                                        position: "relative",
                                      }}
                                    >
                                      <Card.Img
                                        className="imet-fit upload-img mt-0"
                                        src={getAsset(image)}
                                        alt=""
                                        crossOrigin="anonymous"
                                      />
                                      <div
                                        className="close-btnone"
                                        onClick={() => removeImage(index)}
                                      >
                                        <ClearIcon />
                                      </div>
                                    </Card>
                                  ))}
                                </Col>
                              )}
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <Row className="pe-5 ps-5">
                      <div className="mt-3 mb-2">
                         <div className="d-flex align-items-center gap-2">
                           <input
                             type="checkbox"
                             id="terms-checkbox-svcform"
                             checked={termsAcceptedSvc}
                             onChange={(e) => { setTermsAcceptedSvc(e.target.checked); if(e.target.checked) setTermsErrorSvc(false); }}
                             style={{ cursor: "pointer", width: "16px", height: "16px", flexShrink: 0 }}
                           />
                           <label htmlFor="terms-checkbox-svcform" style={{ margin: 0, fontSize: "0.85rem", cursor: "pointer" }}>
                             I agree to the{" "}
                             <span
                               onClick={(e) => { e.preventDefault(); setShowTermsSvcModal(true); }}
                               style={{ color: "#0d6efd", textDecoration: "underline", cursor: "pointer" }}
                             >
                               Terms &amp; Conditions
                             </span>
                           </label>
                         </div>
                         {termsErrorSvc && (
                           <p className="error_text_color" style={{ fontSize: "0.8rem", marginTop: "4px", marginBottom: 0 }}>
                             Please agree to the Terms &amp; Conditions before continuing.
                           </p>
                         )}
                       </div>
                       <div className="btns pb-3">
                        <button
                          type="button"
                          className="btn1"
                          onClick={() => navigate(-1)}
                        >
                          Cancel
                        </button>
                        <button
                          className="btn2 disable-btn"
                          onClick={
                            props.btn === "Create"
                              ? (e) => formSericeSubmit(e)
                              : (e) => servcieFormupdate(e)
                          }
                          disabled={
                            location.pathname === "/create-service"
                              ? !(isValid && dirty)
                              : ""
                          }
                          data-title={
                            location.pathname === `${props.link}${id}`
                              ? null
                              : !(isValid && dirty)
                                ? "Please fill out all Fields to enable button!"
                                : null
                          }
                        >
                          {" "}
                          {props.btn}
                        </button>
                      </div>
                    </Row>
                  </Form>
                )}
              </Formik>
            </div>
          </Col>
        </div>
      </Row>
    </>
  );
};
export default ServiceForm;
